import { ClassAttributes } from 'react';
import Component from '../component/compound/CustomSnackbar';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SNACKBAR_AUTO_HIDE_DURATION = 6000;

const CustomSnackbar = ({ className }: Props) => (
  <DependencyConsumer>
    {(dependency) => (
      <StateConsumer>
        {(state) => (
          <Component
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
            message={state.snackbar.message}
            severity={state.snackbar.severity}
            action={state.snackbar.action || undefined}
            onClickAction={state.snackbar.onClickAction || undefined}
            onRequestClear={() => dependency.messageDispatcher.clearUnimportant()}
            className={className}
          />
        )}
      </StateConsumer>
    )}
  </DependencyConsumer>
);

export default CustomSnackbar;
